import * as React from 'react';
import {
  NumericFormat,
  type NumberFormatValues,
  type NumericFormatProps,
} from 'react-number-format';

interface CustomProps {
  currency?: string;
  onChange: (value: number) => void;
  value: number;
}

export const MoneyInput = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, currency = 'BRL', value, ...inputProps } = props;

    const currencyConfig = {
      DEFAULT: {
        decimalSeparator: '.',
        thousandSeparator: ',',
      },
      BRL: {
        decimalSeparator: ',',
        thousandSeparator: '.',
      },
    };

    const currencyProps =
      currencyConfig[currency as keyof typeof currencyConfig] ??
      currencyConfig.DEFAULT;

    return (
      <NumericFormat
        {...inputProps}
        {...currencyProps}
        allowNegative={false}
        decimalScale={2}
        fixedDecimalScale={true}
        value={value || ''}
        getInputRef={ref}
        onValueChange={(values: NumberFormatValues) => {
          const value = values.floatValue ?? null;
          onChange(value ?? 0);
        }}
        valueIsNumericString
        placeholder="Ex.: R$ 100,00"
      />
    );
  }
);
